import { TableViewItem } from "../../../../../framework/tools/tableview/TableViewItem";
import { GameChatCellView } from "./game_chat_cell_view";
import ModelData, { IUserData } from "../../../../public/model_data";
import * as ProtoPokerRoom from "../../../../table/net/proto/proto_poker_room";
import UserDataManager from "../../../../../manager/user_manager";
const {ccclass, property} = cc._decorator;

@ccclass
export class GameChatCell extends TableViewItem {
    private chatItem:GameChatCellView = null;

    onInit(key:string){
        this.chatItem = this.node.getComponent(GameChatCellView);
    }

    onSetData(key:string, _data:any, index:number, is_measure:boolean):[number, number]{   
        let data =_data.data
        let height = 0;
        let userdata :IUserData = UserDataManager._userDatas[data.playerId.toString()]
        if (!userdata) {
            return [0,0];
        }
        let isRole = data.playerId == ModelData.instance.roleData.id 
        if (data.chatMsg.msgType == 1) {//表情
            let list = data.chatMsg.text.split('_');
            let size = this.chatItem.setEmotion(true,isRole,list[2]);
            height = size.height + 100;
            this.chatItem.setContent(false,isRole);
        }else if (data.chatMsg.msgType == 3) {//文本聊天
            this.chatItem.setContent(true,isRole,data.chatMsg.text);
            this.chatItem.setEmotion(false);
            height = this.chatItem.getHeight() + 100;
        }
        this.chatItem.setAvatar(isRole,userdata.avatar,userdata.gender);
        this.chatItem.setName(isRole,userdata.name);
        this.chatItem.setUserId(data.playerId);
        return [0, height];
    }
}
